import axios from "../axios";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_FORM_URL ?? `${hostConfig.apiBaseUrl}/form-service`;

class FormService {
  // V2
  getFormsV2(uuid = undefined, clientId = undefined, params = {}) {
    return axios
      .get(`${baseUrl}/v2/form${uuid ? `/uuid/${uuid}` : ``}`, {
        params: { ...params, clientId },
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormsV2

  getFormsByIdV2(id, clientId = undefined, params = {}) {
    return axios
      .get(`${baseUrl}/v2/form/${id}`, {
        params: { ...params, clientId },
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormsByIdV2

  getFormAnalyticsV2(formId) {
    return axios
      .get(`${baseUrl}/v2/form/${formId}/analytics`, {
        // params: { ...params, clientId }
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormAnalyticsV2

  createFormSubmissionV2(uuid, body = {}, params = {}) {
    return axios.post(`${baseUrl}/v2/form-submission/uuid/${uuid}`, body, { params }).then((r) => {
      return r?.data;
    });
  } // end createFormSubmissionV2

  createFormSubmissionFileUploadV2(formSubmissionId, body = {}, params = {}) {
    return axios
      .post(`${baseUrl}/v2/form-submission/${formSubmissionId}/file`, body, {
        params,
      })
      .then((r) => {
        return r?.data;
      });
  } // end createFormSubmissionFileUploadV2

  getFormSubmissionFileV2(formSubmissionId, params = {}) {
    return axios
      .get(`${baseUrl}/v2/form-submission/${formSubmissionId}/file`, {
        params: { ...params },
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormSubmissionFileV2

  getFormSubmissionsV2(formId, params = {}) {
    return axios
      .get(`${baseUrl}/v2/form-submission/form/${formId}`, {
        params: { ...params },
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormSubmissionsV2

  getFormFilterOptionsV2(formId, params = {}) {
    return axios
      .get(`${baseUrl}/v2/form/${formId}/filters`, {
        params: { ...params },
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormFilterOptionsV2

  getFormAttachmentFile(formAttachmentId, params = {}) {
    return axios
      .get(`${baseUrl}/v2/form-attachment/${formAttachmentId}/file`, {
        params: { ...params },
      })
      .then((r) => {
        return r?.data;
      });
  } // end getFormSubmissionFileV2

  //Bulk Submissions
  async getBulkClaimSubmissions(params = {}) {
    const response = await axios.get(`${baseUrl}/v2/bulk-claim-submission`, { params });
    return response?.data;
  }

  async getBulkClaimSubmission(id) {
    const response = await axios.get(`${baseUrl}/v2/bulk-claim-submission/${id}`);
    return response?.data;
  }

  async updateBulkClaimSubmissionStatus({ id, status }) {
    const response = await axios.patch(`${baseUrl}/v2/bulk-claim-submission/${id}`, { status });
    return response?.data;
  }

  async deleteBulkClaimSubmission({ bulkClaimSubmissionId, bulkClaimId, status }) {
    const response = await axios.patch(
      `${baseUrl}/v2/bulk-claim-submission/${bulkClaimSubmissionId}/bulk-claim/${bulkClaimId}`,
      { status }
    );
    return response?.data;
  }

  async validateBulkClaimSubmission(formId, claims = []) {
    const response = await axios.post(
      `${baseUrl}/v2/bulk-claim-submission/${formId}/validate`,
      claims
    );
    return response?.data;
  }

  async postBulkClaimSubmission(formId, claims = [], bulkClaimSubmissionId = undefined) {
    const bulkClaimSubmissionIdParam =
      bulkClaimSubmissionId === undefined || bulkClaimSubmissionId === null
        ? ""
        : `?bulkClaimSubmissionId=${encodeURIComponent(String(bulkClaimSubmissionId))}`;
    const response = await axios.post(
      `${baseUrl}/v2/bulk-claim-submission/${formId}${bulkClaimSubmissionIdParam}`,
      claims
    );
    return response?.data;
  }
}

export default new FormService();
